const TableConfig = Object.freeze({
  LIMIT: 100,
  PAGE: 0,
});

export default TableConfig;
